// Librería SheetJS para leer archivos Excel
// Se carga desde CDN en el HTML

// Funciones para descarga de CSV
function downloadCartCSV() {
  try {
    // Obtener los items del carrito desde el data attribute
    const cartItemsData = document.querySelector('.cart-statistics__download-button').getAttribute('data-cart-items');
    const cartItems = JSON.parse(cartItemsData);
    
    if (!cartItems || cartItems.length === 0) {
      alert('No hay items en el carrito para descargar');
      return;
    }
    
    // Crear el contenido del CSV
    let csvContent = 'SKU,Variant ID,Nombre Variante,Cantidad\n';
    
    cartItems.forEach(item => {
      // Obtener el SKU (puede estar en diferentes campos)
      const sku = item.sku || item.variant_id || 'N/A';
      
      // Obtener el variant ID
      const variantId = item.variant_id || 'N/A';
      
      // Obtener el nombre de la variante
      const nombreVariante = item.product_title || item.title || 'N/A';
      
      // Obtener la cantidad
      const cantidad = item.quantity || 0;
      
      // Escapar comillas y crear la línea CSV
      const escapedNombre = `"${nombreVariante.replace(/"/g, '""')}"`;
      csvContent += `${sku},${variantId},${escapedNombre},${cantidad}\n`;
    });
    
    // Crear y descargar el archivo
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    
    link.setAttribute('href', url);
    link.setAttribute('download', `pedido-${new Date().toISOString().split('T')[0]}.csv`);
    link.style.visibility = 'hidden';
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
  } catch (error) {
    console.error('Error al descargar CSV:', error);
    alert('Error al generar el archivo CSV. Por favor, inténtalo de nuevo.');
  }
}

// Funciones para el modal de subida de CSV/Excel
function openCSVUploadModal() {
  document.getElementById('csv-upload-modal').style.display = 'block';
}

function closeCSVUploadModal() {
  document.getElementById('csv-upload-modal').style.display = 'none';
  clearCSVUpload();
}

function handleCSVFileSelect(event) {
  const file = event.target.files[0];
  if (!file) return;
  
  // Verificar el tipo de archivo
  const fileType = file.name.split('.').pop().toLowerCase();
  const isExcel = ['xlsx', 'xls'].includes(fileType);
  const isCSV = fileType === 'csv';
  
  if (!isExcel && !isCSV) {
    alert('Por favor selecciona un archivo CSV o Excel (.csv, .xlsx, .xls)');
    return;
  }
  
  // Mostrar información del archivo
  const fileInfo = document.getElementById('file-info');
  fileInfo.innerHTML = `
    <strong>Archivo seleccionado:</strong> ${file.name}<br>
    <strong>Tipo:</strong> ${isExcel ? 'Excel' : 'CSV'}<br>
    <strong>Tamaño:</strong> ${(file.size / 1024).toFixed(2)} KB
  `;
  
  // Procesar el archivo según su tipo
  if (isExcel) {
    processExcelFile(file);
  } else {
    processCSVFile(file);
  }
}

function processExcelFile(file) {
  const reader = new FileReader();
  
  reader.onload = function(e) {
    try {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      
      // Obtener la primera hoja
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];
      
      // Convertir a JSON
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      
      if (jsonData.length < 2) {
        alert('El archivo Excel debe tener al menos una línea de encabezado y una línea de datos.');
        return;
      }
      
      // Procesar los datos como si fuera CSV
      const items = processExcelData(jsonData);
      
      if (items.length === 0) {
        alert('No se encontraron items válidos en el archivo Excel.');
        return;
      }
      
      // Mostrar vista previa
      showPreview(items);
      
    } catch (error) {
      console.error('Error al procesar archivo Excel:', error);
      alert('Error al procesar el archivo Excel. Verifica que el formato sea correcto.');
    }
  };
  
  reader.readAsArrayBuffer(file);
}

function processExcelData(jsonData) {
  const items = [];
  
  // Obtener encabezados (primera fila)
  const headers = jsonData[0].map(header => String(header).trim());
  
  // Verificar que los encabezados sean correctos
  const expectedHeaders = ['SKU', 'Variant ID', 'Nombre Variante', 'Cantidad'];
  const isValidFormat = expectedHeaders.every(header => 
    headers.some(h => String(h).toLowerCase().includes(header.toLowerCase()))
  );
  
  if (!isValidFormat) {
    alert('El formato del archivo Excel no es válido. Debe contener: SKU, Variant ID, Nombre Variante, Cantidad');
    return [];
  }
  
  // Procesar filas de datos (excluyendo la primera fila de encabezados)
  for (let i = 1; i < jsonData.length; i++) {
    const row = jsonData[i];
    
    if (row.length >= 4) {
      const sku = String(row[0] || '').trim();
      const variantId = String(row[1] || '').trim();
      const nombreVariante = String(row[2] || '').trim();
      const cantidad = parseInt(row[3]);
      
      // Validar que la cantidad sea un número válido y mayor a 0
      if (!isNaN(cantidad) && cantidad > 0 && variantId) {
        items.push({
          sku: sku,
          variant_id: variantId,
          nombre_variante: nombreVariante,
          quantity: cantidad
        });
      }
    }
  }
  
  return items;
}

function processCSVFile(file) {
  processCSV(file).then(items => {
    showPreview(items);
  }).catch(error => {
    alert(error);
  });
}

function processCSV(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    
    reader.onload = function(e) {
      try {
        const csv = e.target.result;
        // Dividir por líneas y filtrar líneas vacías
        const lines = csv.split('\n').filter(line => line.trim() !== '');
        
        if (lines.length < 2) {
          reject('El archivo CSV debe tener al menos una línea de encabezado y una línea de datos.');
          return;
        }
        
        // Detectar automáticamente el separador
        const firstLine = lines[0];
        let separator = ',';
        
        // Si la primera línea contiene punto y coma, usar punto y coma
        if (firstLine.includes(';')) {
          separator = ';';
        }
        
        // Obtener encabezados (primera línea)
        const headers = parseCSVLine(firstLine, separator).map(header => header.trim());
        
        // Verificar que los encabezados sean correctos
        const expectedHeaders = ['SKU', 'Variant ID', 'Nombre Variante', 'Cantidad'];
        const isValidFormat = expectedHeaders.every(header => 
          headers.some(h => h.toLowerCase().includes(header.toLowerCase()))
        );
        
        if (!isValidFormat) {
          reject('El formato del CSV no es válido. Debe contener: SKU, Variant ID, Nombre Variante, Cantidad');
          return;
        }
        
        // Procesar líneas de datos (excluyendo la primera línea de encabezados)
        const items = [];
        for (let i = 1; i < lines.length; i++) {
          const line = lines[i].trim();
          if (line === '') continue;
          
          const values = parseCSVLine(line, separator).map(value => value.trim());
          
          if (values.length >= 4) {
            const sku = values[0];
            const variantId = values[1];
            const nombreVariante = values[2];
            const cantidad = parseInt(values[3]);
            
            // Validar que la cantidad sea un número válido y mayor a 0
            if (!isNaN(cantidad) && cantidad > 0 && variantId) {
              items.push({
                sku: sku,
                variant_id: variantId,
                nombre_variante: nombreVariante,
                quantity: cantidad
              });
            }
          }
        }
        
        if (items.length === 0) {
          reject('No se encontraron items válidos en el CSV. Verifica que las cantidades sean números mayores a 0.');
          return;
        }
        
        resolve(items);
      } catch (error) {
        reject('Error al procesar el archivo CSV: ' + error.message);
      }
    };
    
    reader.onerror = function() {
      reject('Error al leer el archivo.');
    };
    
    reader.readAsText(file);
  });
}

// Función auxiliar para parsear líneas CSV con manejo de comillas
function parseCSVLine(line, separator) {
  const result = [];
  let current = '';
  let inQuotes = false;
  
  for (let i = 0; i < line.length; i++) {
    const char = line[i];
    
    if (char === '"') {
      inQuotes = !inQuotes;
    } else if (char === separator && !inQuotes) {
      result.push(current);
      current = '';
    } else {
      current += char;
    }
  }
  
  // Agregar el último campo
  result.push(current);
  
  // Limpiar comillas de los campos
  return result.map(field => field.replace(/^"|"$/g, ''));
}

function showPreview(items) {
  const previewContent = document.getElementById('csv-preview-content');
  const preview = document.getElementById('csv-preview');
  const actions = document.getElementById('csv-upload-actions');
  
  // Verificar límite de Shopify (máximo 499 productos)
  const SHOPIFY_LIMIT = 499;
  let warningMessage = '';
  
  if (items.length > SHOPIFY_LIMIT) {
    warningMessage = `
      <div class="csv-warning" style="background-color: #fff3cd; border: 1px solid #ffeaa7; color: #856404; padding: 1rem; border-radius: 0.4rem; margin-bottom: 1rem;">
        <strong>⚠️ Advertencia:</strong> Tu archivo contiene <strong>${items.length} productos</strong>, pero Shopify solo permite un máximo de <strong>${SHOPIFY_LIMIT} productos</strong> por carrito.
        <br><br>
        <strong>Recomendaciones:</strong>
        <ul style="margin: 0.5rem 0; padding-left: 1.5rem;">
          <li>Divide tu pedido en archivos más pequeños</li>
          <li>Elimina productos innecesarios del archivo</li>
          <li>Procesa el pedido en múltiples carritos</li>
        </ul>
        <br>
        <strong>Nota:</strong> Si continúas, solo se procesarán los primeros ${SHOPIFY_LIMIT} productos.
      </div>
    `;
  }
  
  // Crear tabla de vista previa
  let previewHTML = `
    ${warningMessage}
    <h4>Vista previa del archivo (${items.length} items encontrados):</h4>
    <table class="csv-preview-table">
      <thead>
        <tr>
          <th>SKU</th>
          <th>Variant ID</th>
          <th>Nombre Variante</th>
          <th>Cantidad</th>
        </tr>
      </thead>
      <tbody>
  `;
  
  // Mostrar solo los primeros items si excede el límite
  const itemsToShow = items.length > SHOPIFY_LIMIT ? items.slice(0, SHOPIFY_LIMIT) : items;
  
  itemsToShow.forEach(item => {
    previewHTML += `
      <tr>
        <td>${item.sku}</td>
        <td>${item.variant_id}</td>
        <td>${item.nombre_variante}</td>
        <td>${item.quantity}</td>
      </tr>
    `;
  });
  
  if (items.length > SHOPIFY_LIMIT) {
    previewHTML += `
      <tr style="background-color: #f8f9fa; font-style: italic;">
        <td colspan="4" style="text-align: center; color: #856404;">
          ... y ${items.length - SHOPIFY_LIMIT} productos más (no mostrados)
        </td>
      </tr>
    `;
  }
  
  previewHTML += `
      </tbody>
    </table>
  `;
  
  previewContent.innerHTML = previewHTML;
  preview.style.display = 'block';
  actions.style.display = 'block';
}

function clearCSVUpload() {
  document.getElementById('csv-file-input').value = '';
  document.getElementById('file-info').innerHTML = '';
  document.getElementById('csv-preview-content').innerHTML = '';
  document.getElementById('csv-preview').style.display = 'none';
  document.getElementById('csv-upload-actions').style.display = 'none';
}

async function processCSVAndUpdateCart() {
  const fileInput = document.getElementById('csv-file-input');
  const file = fileInput.files[0];
  
  if (!file) {
    alert('Por favor, selecciona un archivo CSV o Excel.');
    return;
  }

  try {
    let cartItems;
    
    // Procesar según el tipo de archivo
    const fileType = file.name.split('.').pop().toLowerCase();
    const isExcel = ['xlsx', 'xls'].includes(fileType);
    
    if (isExcel) {
      // Para Excel, ya tenemos los items procesados, solo necesitamos obtenerlos de la vista previa
      const previewTable = document.querySelector('.csv-preview-table tbody');
      if (!previewTable) {
        alert('Por favor, primero sube y revisa el archivo.');
        return;
      }
      
      cartItems = [];
      const rows = previewTable.querySelectorAll('tr');
      rows.forEach(row => {
        const cells = row.querySelectorAll('td');
        if (cells.length >= 4) {
          cartItems.push({
            sku: cells[0].textContent,
            variant_id: cells[1].textContent,
            nombre_variante: cells[2].textContent,
            quantity: parseInt(cells[3].textContent)
          });
        }
      });
    } else {
      // Para CSV, usar la función existente
      cartItems = await processCSV(file);
    }
    
    if (cartItems.length === 0) {
      alert('No hay items válidos para actualizar el carrito.');
      return;
    }

    // Verificar límite de Shopify antes de procesar
    const SHOPIFY_LIMIT = 499;
    if (cartItems.length > SHOPIFY_LIMIT) {
      const confirmMessage = `Tu archivo contiene ${cartItems.length} productos, pero Shopify solo permite un máximo de ${SHOPIFY_LIMIT} productos por carrito.\n\nSi continúas, solo se procesarán los primeros ${SHOPIFY_LIMIT} productos.\n\n¿Deseas continuar con esta limitación?`;
      
      if (!confirm(confirmMessage)) {
        return;
      }
      
      // Limitar a los primeros 499 productos
      cartItems = cartItems.slice(0, SHOPIFY_LIMIT);
    }

    // Actualizar el carrito con los nuevos items
    await updateCartWithCSV(cartItems);
    
    // Cerrar modal y limpiar
    closeCSVUploadModal();
    clearCSVUpload();
    
  } catch (error) {
    console.error('Error al procesar archivo:', error);
    alert('Error al procesar el archivo. Por favor, inténtalo de nuevo.');
  }
}

async function updateCartWithCSV(cartItems) {
  try {
    // Mostrar indicador de carga
    const processButton = document.querySelector('.csv-upload-actions button:not(.secondary)');
    const originalText = processButton.textContent;
    processButton.textContent = 'Procesando...';
    processButton.disabled = true;
    
    // Primero, limpiar el carrito actual
    await fetch('/cart/clear.js', { method: 'POST' });
    
    // Preparar los items para agregar al carrito
    const itemsToAdd = cartItems
      .filter(item => item.quantity > 0 && item.variant_id)
      .map(item => ({
        id: parseInt(item.variant_id),
        quantity: parseInt(item.quantity)
      }));
    
    if (itemsToAdd.length === 0) {
      alert('No hay items válidos para agregar al carrito.');
      return;
    }
    
    // Agregar todos los items al carrito usando la API de Shopify
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items: itemsToAdd })
    });
    
    if (!response.ok) {
      throw new Error(`Error HTTP: ${response.status}`);
    }
    
    const result = await response.json();
    
    if (result.status === 422) {
      // Error de validación - mostrar detalles
      const errorMessage = result.description || 'Error al agregar items al carrito.';
      alert(`Error: ${errorMessage}\n\nVerifica que los Variant IDs sean correctos y que los productos estén disponibles.`);
      return;
    }
    
    // Éxito - recargar la página para mostrar el carrito actualizado
    alert(`¡Éxito! Se agregaron ${itemsToAdd.length} items al carrito.`);
    window.location.reload();
    
  } catch (error) {
    console.error('Error al actualizar carrito:', error);
    alert('Error al actualizar el carrito. Por favor, inténtalo de nuevo.');
  } finally {
    // Restaurar botón
    const processButton = document.querySelector('.csv-upload-actions button:not(.secondary)');
    processButton.textContent = originalText;
    processButton.disabled = false;
  }
}

// Función para vaciar el carrito
async function clearCart() {
  // Confirmar con el usuario antes de vaciar
  if (!confirm('¿Estás seguro de que quieres vaciar el carrito? Esta acción no se puede deshacer.')) {
    return;
  }
  
  try {
    // Mostrar indicador de carga
    const clearButton = document.querySelector('.cart-statistics__clear-button');
    const originalText = clearButton.textContent;
    const originalHTML = clearButton.innerHTML;
    
    clearButton.innerHTML = '<svg class="cart-statistics__clear-icon" width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/></svg>Vaciando...';
    clearButton.style.pointerEvents = 'none';
    
    // Llamar a la API de Shopify para vaciar el carrito
    const response = await fetch('/cart/clear.js', { 
      method: 'POST' 
    });
    
    if (!response.ok) {
      throw new Error(`Error HTTP: ${response.status}`);
    }
    
    // Éxito - mostrar mensaje y recargar la página
    alert('Carrito vaciado exitosamente.');
    window.location.reload();
    
  } catch (error) {
    console.error('Error al vaciar carrito:', error);
    alert('Error al vaciar el carrito. Por favor, inténtalo de nuevo.');
  } finally {
    // Restaurar botón
    const clearButton = document.querySelector('.cart-statistics__clear-button');
    clearButton.innerHTML = originalHTML;
    clearButton.style.pointerEvents = 'auto';
  }
}

// Inicialización cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', function() {
  // Configurar drag and drop para el área de subida
  const uploadArea = document.querySelector('.csv-upload-area');
  const fileInput = document.getElementById('csv-file-input');
  
  if (uploadArea && fileInput) {
    // Prevenir comportamiento por defecto del navegador
    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
      uploadArea.addEventListener(eventName, preventDefaults, false);
      document.body.addEventListener(eventName, preventDefaults, false);
    });
    
    // Efectos visuales durante drag
    ['dragenter', 'dragover'].forEach(eventName => {
      uploadArea.addEventListener(eventName, highlight, false);
    });
    
    ['dragleave', 'drop'].forEach(eventName => {
      uploadArea.addEventListener(eventName, unhighlight, false);
    });
    
    // Manejar archivo soltado
    uploadArea.addEventListener('drop', handleDrop, false);
    
    // Click en el área para abrir selector de archivos
    uploadArea.addEventListener('click', () => fileInput.click());
    
    // Remover el evento onchange del HTML para evitar doble procesamiento
    fileInput.removeAttribute('onchange');
    
    // Agregar el evento change programáticamente
    fileInput.addEventListener('change', handleCSVFileSelect);
  }
});

function preventDefaults(e) {
  e.preventDefault();
  e.stopPropagation();
}

function highlight(e) {
  const uploadArea = document.querySelector('.csv-upload-area');
  if (uploadArea) {
    uploadArea.classList.add('dragover');
  }
}

function unhighlight(e) {
  const uploadArea = document.querySelector('.csv-upload-area');
  if (uploadArea) {
    uploadArea.classList.remove('dragover');
  }
}

function handleDrop(e) {
  const dt = e.dataTransfer;
  const files = dt.files;
  
  if (files.length > 0) {
    const fileInput = document.getElementById('csv-file-input');
    if (fileInput) {
      fileInput.files = files;
      // Crear un evento sintético para evitar doble procesamiento
      const changeEvent = new Event('change', { bubbles: true });
      fileInput.dispatchEvent(changeEvent);
    }
  }
}
